import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { H4 } from 'components/Text/H4';

import { Description } from './JobSelector.styled';

type Props = {
  content: {
    name: ReactNode;
    body?: ReactNode;
    description?: string;
  };
  cta?: ReactNode;
};

export function Card({ content: { name, body, description }, cta }: Props) {
  return (
    <Box py={[12, null, 24]} px={[24, null, 44]}>
      <H4 mb={0}>{name}</H4>
      {body}
      {description && (
        <Description
          styleAs="bodySmall"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
      {cta && (
        <Box mt="20px" mb="15px">
          {cta}
        </Box>
      )}
    </Box>
  );
}
